<template>
  <div class="wrap-document">
    <div class="page">
      <div class="top"></div>
      <img src="" alt="" />
      <p class="title">BUKTI KONFIRMASI NASABAH</p>
      <div class="content">
        <p>Terima kasih atas permintaan real account Anda. Permintaan anda telah berhasil diproses.</p>
        <p>Di bawah ini adalah rincian account baru Anda:</p>
        <p>REAL ACCOUNT INFO</p>
        <div class="format-text"><label>Date/TIme</label> : {{ dataConfirmation.order_date | formatDate }}</div>
        <div class="format-text"><label>Order Number</label> : {{ dataConfirmation.order_no }}</div>
        <div class="format-text"><label>FullName</label> : {{ dataConfirmation.customer.fullname }}</div>
        <div class="format-text">
          <label>Email</label> : <span class="lowercase">{{ dataConfirmation.user.email }}</span>
        </div>
      </div>
      <div class="content">
        <div>
          <b>{{ dataConfirmation.trade_account.platform_name }}</b>
          <div>
            <div class="format-text"><label>Platform ID</label> : {{ dataConfirmation.trade_account.platform_code }}</div>
            <div class="format-text"><label>Username</label> : {{ dataConfirmation.trade_account.username }}</div>
            <div class="format-text">
              <label>Password</label> : <span class="lowercase">{{ dataConfirmation.trade_account.password }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <p>Terima kasih telah mempercayai ABI Komoditi Berjangka. Kami menyarankan Anda untuk segera mengubah kata sandi Anda untuk keamanan Anda sendiri.</p>
        <p>Jika ada pertanyaan lebih lanjut, mohon jangan ragu untuk menghubungi kami</p>
      </div>
      <div class="content">
        Hormat Kami,
        <div>PT ABI Komoditi Berjangka</div>
        <p>Menara Rajawali lt 6 Jl. DR Ide Anak Agung Gde Agung Setiabudi Kuningan Timur Jakarta Selatan 12950</p>
      </div>
      <div class="persetujuan">
        Mengetahui,
        <div class="wrap-ttd">
          <div class="ttd">
            <img :src="signature_director" alt="" class="tanda-tangan" />
            <p class="format-text">{{ dataBroker.director_name }}</p>
            <p class="format-text">Direktur Utama</p>
          </div>
          <div class="ttd">
            <img :src="signature_broker" alt="" class="tanda-tangan" />
            <p class="format-text">{{ dataBroker.broker_name }}</p>
            <p class="format-text">Wakil Pialang</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  props: {
    fullName: String,
    dataPrint: Object,
  },
  data() {
    return {
      currentDate: "",
      dataBroker: [],
      dataTradeAccount: [],
      dataConfirmation: [],
      signature_director: "",
      signature_broker: "",
    };
  },
  mounted() {
    let id = this.$route.params.id;
    let token = this.$route.query.token;
    this.currentDate = new Date();
    Axios.get("/v2/internal/kyc/trade-account/" + id, {
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }).then((res) => {
      this.dataConfirmation = res.data.data;
      this.dataBroker = this.dataConfirmation.broker;
      Axios.get("/v2/internal/get" + this.dataBroker.director_signature, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "arraybuffer",
      }).then((res) => {
        let data = `data:${res.headers["content-type"]};base64,${new Buffer(res.data, "binary").toString("base64")}`;
        this.signature_director = data;
      });
      Axios.get("/v2/internal/get" + this.dataBroker.broker_signature, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "arraybuffer",
      }).then((res) => {
        let data = `data:${res.headers["content-type"]};base64,${new Buffer(res.data, "binary").toString("base64")}`;
        this.signature_broker = data;
      });
    });
  },
};
</script>

<style scoped>
label {
  width: 100px;
}
.page {
  padding: 1cm;
  /* border: 5px red solid; */
  height: 257mm;
  /* outline: 2cm #FFFFFF solid; */
}

/* .format-text {
  text-transform: capitalize;
}

.format-text::first-letter,
.format-text::first-line {
  text-transform: capitalize;
} */

.wrap-document {
  /* width: 210mm; */
  min-height: 297mm;
  padding: 10mm;
  margin: 10mm auto;
  /* border: 1px #D3D3D3 solid; */
  border-radius: 5px;
  background: white;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  position: relative;
}

.tanda-tangan {
  width: 20%;
  padding: 0.5rem 0;
}

.top {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 25px;
}

.nomor {
  font-weight: bold;
}

.lampiran p {
  margin: 0;
  text-align: right;
}

.title {
  font-weight: bold;
  text-align: center;
  margin: 40px auto !important;
  font-size: 14px;
}

.content {
  font-size: 13px;
  text-align: justify;
}

.sub-content {
  font-weight: 700;
}

form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
}

label {
  margin-right: 15px;
}

.penutup {
  text-align: center;
  font-size: 12px;
}

.penutup p {
  margin: 0;
}

.resiko {
  font-weight: 700;
}

.persetujuan {
  font-size: 13px;
  margin: 30px 0 90px;
}

.wrap-ttd {
  display: flex;
  justify-content: space-between;
}

.tanggal {
  margin-left: auto;
  margin-bottom: 10px !important;
}

.jabatan {
  margin-bottom: 70px !important;
}

.pt-abi {
  display: block !important;
  margin: 20px auto;
  width: 50%;
}

.pt-abi p {
  width: auto !important;
}

.footer {
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  position: absolute;
  width: 80%;
  bottom: 0;
}

@page {
  size: A4;
  margin: 0;
}

@media (max-width: 768px) {
  .page {
    padding: 0;
  }

  .title {
    margin: 20px auto !important;
  }
}
</style>
